import React, { Component } from 'react';
import { Col, Row } from 'antd';
import QueueAnim from 'rc-queue-anim';
import { Link } from 'react-router-dom'
import axios from "axios"

const baseURL = process.env.REACT_APP_API_URL;

class Foot extends Component {

    constructor(props) {
        super(props);
        this.state = {
            about_us: [],
            downloads: [],
            categorys: props.categorys || [],
        };
    }
    componentDidMount() {
        // axios.get(`http://www.as-gold.net/api/data.php?t=about_us`).then(res => {
        //     const about_us = res.data;
        //     this.setState({ about_us: about_us });
        // })
        axios.post(baseURL + 'aboutUs/list',{}).then(res => {
            const about_us = res.data.list;
            this.setState({ about_us: about_us });
        })
        // axios.get(`http://www.as-gold.net/api/data.php?t=downloads`).then(res => {
        //     const downloads = res.data;
        //     this.setState({ downloads: downloads });
        // })
        axios.post(baseURL + 'downloads/list',{}).then(res => {
            const downloads = res.data.list;
            this.setState({ downloads: downloads });
        })
    }

    render() {
        return (
            <QueueAnim type="bottom" interval={500}>
                <Row key="about_us" gutter={8} type="flex" justify="center" align="top" style={{ marginTop: 32 }}>
                    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                        <h2>关于我们</h2>
                        {this.state.about_us.map(item => {
                            return (
                                <p key={item.id}> {item.keyword}</p>
                            )
                        })}
                    </Col>
                    {this.state.categorys.map(category => {
                        return (
                            <Col key={category.id} xs={12} sm={12} md={12} lg={6} xl={6}>
                                <h2> {category.name}</h2>
                                {category.children.map(sub_category => {
                                    return (<p key={sub_category.id}><Link to={"/category/" + sub_category.id}>{sub_category.name}</Link></p>)
                                })
                                }
                            </Col>
                        )
                    })}

                    <Col key="d" xs={12} sm={12} md={12} lg={6} xl={6}>
                        <h2>资料 </h2>
                        {this.state.downloads.map(item => {
                            return (
                                <a key={item.id} href={item.url}>{item.name}</a>
                            )
                        })}
                    </Col>
                </Row>
                <Row key="c" gutter={8} type="flex" justify="center" align="top">
                    <Col span={24} style={{ marginTop: 32, textAlign: "center", color: "#666!important" }}>
                        <p>© 2009-2018 as-gold.net 版权所有 ICP证：<a href="https://beian.miit.gov.cn/">辽ICP备18004992号-1 </a> </p>
                    </Col>
                </Row>
                <Row key="p" gutter={8} type="flex" justify="center" align="top">
                    <Col span={24} style={{ marginTop: 8, textAlign: "center", color: "#666!important" }}>
                        <p> 由 <a href="https://www.weyha.com">唯恒科技 www.weyha.com</a> 提供技术支持</p>
                    </Col>
                </Row>
            </QueueAnim>

        );
    }
}

export default Foot;
